import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosConfig";
import ContributionUpdate from "./ContributionUpdate";
import './ContributionPage.css'

const ContributionsPage = () => {
  const [userContributions, setUserContributions] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [loading, setLoading] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);

  useEffect(() => {
    fetchUserContributions();
    fetchLeaderboard();
  }, [selectedQuarter]);

  const fetchUserContributions = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/user_contributions/");
      setUserContributions(response.data.contributions);
    } catch (error) {
      console.error("Error fetching user contributions:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const url = selectedQuarter
        ? `/leaderboard_by_quarter/?quarter=${selectedQuarter}`
        : "/leaderboard/";
      const response = await axiosInstance.get(url);
      setLeaderboard(response.data.leaderboard);
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="contributions-container">
        <header className="contributions-header">
          <h1>Data Revisions</h1>
          <div className="prize-container">
            <p className="prize-notice">2025-Q4 Prize Pool: $1000</p>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="info-icon"
                onClick={() => setIsOverlayVisible(true)}
            >
              <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
              />
            </svg>
          </div>
        </header>

        {isOverlayVisible && (
  <div className="overlay">
    <div className="overlay-content">
      <h2 className="overlay-title">Prize Pool Details</h2>

      <div className="overlay-section">
        <p>
          The top 10 contributors for Q4 2025 (Oct-Dec) will each receive a $100 digital gift card,
          delivered via email by January 15th, 2026.
        </p>
      </div>

      <div className="overlay-section">
        <p><strong>Point System:</strong></p>
        <ul className="overlay-list">
          <li>Missing Club submissions: 10 points</li>
          <li>All other data corrections: 5 points</li>
        </ul>
      </div>

      <div className="overlay-section">
        <p>
          All contributions are reviewed by our research team. Only approved submissions count
          toward your total points on the leaderboard.
        </p>
      </div>

      <button
        className="close-overlay-button"
        onClick={() => setIsOverlayVisible(false)}
      >
        Close
      </button>
    </div>
  </div>
)}

        <section className="contributions-section">
          <div className="section-header2">
            <h2>Your Contributions</h2>
            <button
                className="primary-btn"
                onClick={() => setShowUpdateForm(true)}
            >
              + Submit Update
            </button>
          </div>

          {loading ? (
              <div className="loading-spinner"></div>
          ) : userContributions.length > 0 ? (
              <div className="table-container">
                <table className="contributions-table">
                  <thead>
                  <tr>
                    <th>Course ID</th>
                    <th>Categories</th>
                    <th>Status</th>
                    <th>Points</th>
                    <th>Submitted</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userContributions.map((contribution) => (
                      <tr key={contribution.id}>
                        <td>{contribution.course_id || "N/A"}</td>
                        <td>{contribution.categories?.join(", ") || "N/A"}</td>
                        <td>
                      <span className={`status-pill ${contribution.status.toLowerCase()}`}>
                        {contribution.status}
                      </span>
                        </td>
                        <td>{contribution.points}</td>
                        <td>{new Date(contribution.submitted_at).toLocaleDateString()}</td>
                      </tr>
                  ))}
                  </tbody>
                </table>
              </div>
          ) : (
              <div className="empty-state">
                <p>No contributions submitted yet</p>
              </div>
          )}
        </section>

        <section className="contributions-section">
          <div className="section-header2">
            <h2>Leaderboard</h2>
            <select
                className="quarter-select"
                value={selectedQuarter}
                onChange={(e) => setSelectedQuarter(e.target.value)}
            >
              // <option value="">All Time</option>
              <option value="2025-Q4">2025-Q4</option>
            </select>
          </div>

          {loading ? (
              <div className="loading-spinner"></div>
          ) : leaderboard.length > 0 ? (
              <div className="table-container">
                <table className="leaderboard-table">
                  <thead>
                  <tr>
                    <th>Rank</th>
                    <th>User</th>
                    <th>Points</th>
                  </tr>
                  </thead>
                  <tbody>
                  {leaderboard.map((user, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{user.username}</td>
                        <td>{user.total_points}</td>
                      </tr>
                  ))}
                  </tbody>
                </table>
              </div>
          ) : (
              <div className="empty-state">
                <p>No leaderboard data available</p>
              </div>
          )}
        </section>

        {showUpdateForm && (
            <ContributionUpdate
                courseId={null}
                onClose={() => setShowUpdateForm(false)}
            />
        )}
      </div>
  );
};

export default ContributionsPage;
